export const detectBrowser = () => {
  if (typeof window === "undefined" || !window.navigator) return undefined;

  const ua = window.navigator.userAgent;

  if (ua.indexOf("Edg/") > -1) {
    return "Edge";
  } else if (ua.indexOf("Chrome") > -1 && ua.indexOf("Chromium") === -1) {
    return "Chrome";
  } else if (ua.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) {
    return "Safari";
  } else if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR/") > -1) {
    return "Opera";
  }

  return "other";
};

// Mantine hooks covers this
export const detectOS = () => {
  if (typeof window === "undefined" || !window) return undefined;
  if (typeof navigator === "undefined" || !navigator) return undefined;

  const userAgent = window.navigator.userAgent.toLowerCase();
  const platform = window.navigator.platform.toLowerCase();

  const macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i;
  const windowsPlatforms = /(win32|win64|windows|wince)/i;
  const iosPlatforms = /(iphone|ipad|ipod)/i;

  if (macosPlatforms.test(platform)) {
    return "macos";
  } else if (
    iosPlatforms.test(platform) ||
    /iphone|ipad|ipod/.test(userAgent)
  ) {
    return "ios";
  } else if (windowsPlatforms.test(userAgent)) {
    return "windows";
  } else if (
    /android/.test(userAgent) ||
    /linux armv|linux aarch64/.test(platform)
  ) {
    return "android";
  } else if (/linux/.test(platform)) {
    return "linux";
  } else {
    return "other";
  }
};
